import { render, staticRenderFns } from "./statewide-add-parts.vue?vue&type=template&id=3f2f84c3&scoped=true"
import script from "./statewide-add-parts.vue?vue&type=script&lang=js"
export * from "./statewide-add-parts.vue?vue&type=script&lang=js"
import style0 from "./statewide-add-parts.vue?vue&type=style&index=0&id=3f2f84c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f84c3",
  null
  
)

export default component.exports